import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Grid from '@mui/material/Grid';
import MenuIcon from "@mui/icons-material/Menu";
import { LanguageSelector } from "../LanguageSelector";
// import LifeSaferLogo from "@/_images/logos/LogoLimited.png";
import Button from "@mui/material/Button";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import Box from "@mui/system/Box";
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.up("md")]: { display: "none" },
    [theme.breakpoints.up("sm")]: {
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
}));

const Logo = styled("img")(({ theme,isISA }) => ({
  [theme.breakpoints.up("sm")]: {
    width: 168,
    height:isISA ?"49px": 34,
  },
  [theme.breakpoints.down("sm")]: {
    width: 109,
    height:isISA ?"22": 22,
  },
}));

const NavToolBar = ({
  handleDrawerToggle,
  phoneNumber,
  // setMobileOpen,
  // updateSelectedNav,
  // referralSiteData,
   siteLogo,
  isISA,
}) => {
      const isLessThan365 = useMediaQuery("(max-width:365px)");
      const isLessThan380 = useMediaQuery("(max-width:380px)");
  return (
    <Toolbar sx={{ width: "100%", justifyContent: "space-between",px:1,minHeight:"56px !important" }}>
      <Grid sx={{ display: "flex", alignItems: "center", gap: isLessThan365 ? "12px": (isLessThan380 ? "18px":"28px") }}>
        <StyledIconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          size="large"
          sx={{ flexShrink: 0 }}
        >
          <MenuIcon sx={{ color: "#76bc21" }} />
        </StyledIconButton>
        {/* <RouterLink href={referralSiteData ?? `https://www.lifesafer.com`} onClick={() => onNavClick("/")}> */}
        <Box sx={{ml:"-17px"}}>
          <Logo
            component="img"
            // style={{ marginTop: "5px" }}
            src={siteLogo}
            isISA={isISA}
            alt="LifeSafer"
          />
        </Box>
        {/* </RouterLink> */}
        <Grid sx={{ display: { xs: "block", sm: "none" } }}>
          <Button
            type="submit"
            size="small"
            variant="outlined"
            // color="primary"
            startIcon={<PhoneIphoneIcon />}
            style={{ height: 35, width: "max-content",marginRight:"10px"}}
            component="a"
            href={`tel:${phoneNumber}`}

          >
            {phoneNumber}
          </Button>
        </Grid>
      </Grid>

      <Grid container justifyContent="flex-end" alignItems="center" spacing={1}>
        <Grid sx={{ mt: -0.5 }}>
          <LanguageSelector />
        </Grid>
      </Grid>
    </Toolbar>
  );
};

NavToolBar.propTypes = {
  unreadNotifications: PropTypes.number.isRequired,
  selectedNav: PropTypes.string.isRequired,
  invisible: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  setMobileOpen: PropTypes.func.isRequired,
  updateSelectedNav: PropTypes.func.isRequired,
  referralSiteData: PropTypes.string,
  phoneNumber: PropTypes.string,
  siteLogo:PropTypes.string,
  isISA:PropTypes.bool,
};

export { NavToolBar };
